import { Phone } from 'lucide-react';

export const FloatingCTA = () => {
  return (
    <a
      href="https://pancungradi.simplybook.it/v2/#book"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-cta"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-gold hover:bg-gold-light text-navy font-bold py-3 px-5 rounded-full shadow-lg shadow-gold/30 hover:shadow-gold/50 transition-all duration-300 hover:-translate-y-1"
    >
      <Phone className="w-5 h-5" />
      <span className="hidden sm:inline">Zavolat ZDARMA</span>
    </a>
  );
};
